(() => {
  const normalize = (value) =>
    String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase('tr-TR');

  const translations = new Map(
    Object.entries({
      'Buy it now': 'Şimdi satın al',
      'Buy now': 'Şimdi satın al',
      'Pay now': 'Şimdi öde',
      'Add to cart': 'Sepete ekle',
      'Adding...': 'Ekleniyor...',
      'Added to cart': 'Sepete eklendi',
      'Sold out': 'Tükendi',
      Unavailable: 'Mevcut değil',
      Available: 'Mevcut',
      'Choose options': 'Seçenekleri seç',
      'Select options': 'Seçenekleri seç',
      'Quick add': 'Hızlı ekle',
      'View product': 'Ürünü görüntüle',
      'View full details': 'Tüm ayrıntıları gör',
      'View details': 'Ayrıntıları gör',
      'Continue shopping': 'Alışverişe devam et',
      Checkout: 'Ödemeye geç',
      'Proceed to checkout': 'Ödemeye geç',
      'View cart': 'Sepeti görüntüle',
      Cart: 'Sepet',
      'Your cart': 'Sepetiniz',
      'Your cart is empty': 'Sepetiniz boş',
      'Estimated total': 'Tahmini toplam',
      Subtotal: 'Ara toplam',
      Total: 'Toplam',
      Discounts: 'İndirimler',
      Discount: 'İndirim',
      'Apply discount': 'İndirim uygula',
      'Discount code': 'İndirim kodu',
      'Order note': 'Sipariş notu',
      'Special instructions': 'Özel talimatlar',
      Search: 'Ara',
      'Search results': 'Arama sonuçları',
      'No results': 'Sonuç bulunamadı',
      'No results found': 'Sonuç bulunamadı',
      Products: 'Ürünler',
      Collections: 'Koleksiyonlar',
      Pages: 'Sayfalar',
      Articles: 'Yazılar',
      Availability: 'Stok durumu',
      Price: 'Fiyat',
      'Product type': 'Ürün türü',
      'Product Type': 'Ürün türü',
      Vendor: 'Marka',
      Brand: 'Marka',
      Category: 'Kategori',
      Color: 'Renk',
      Size: 'Boyut',
      Quantity: 'Adet',
      'Decrease quantity': 'Adedi azalt',
      'Increase quantity': 'Adedi artır',
      'Regular price': 'Normal fiyat',
      'Sale price': 'İndirimli fiyat',
      'Compare at price': 'Karşılaştırma fiyatı',
      'Sort by': 'Sırala',
      Sort: 'Sırala',
      Featured: 'Öne çıkanlar',
      'Best selling': 'Çok satanlar',
      'Alphabetically, A-Z': 'Alfabetik, A-Z',
      'Alphabetically, Z-A': 'Alfabetik, Z-A',
      'Price, low to high': 'Fiyat, düşükten yükseğe',
      'Price, high to low': 'Fiyat, yüksekten düşüğe',
      'Date, old to new': 'Tarih, eskiden yeniye',
      'Date, new to old': 'Tarih, yeniden eskiye',
      Newest: 'En yeni',
      Oldest: 'En eski',
      Relevance: 'En alakalı',
      'In stock': 'Stokta',
      'Out of stock': 'Stokta yok',
      Filter: 'Filtrele',
      Filters: 'Filtreler',
      'More filters': 'Diğer filtreler',
      Clear: 'Temizle',
      'Clear all': 'Tümünü temizle',
      Apply: 'Uygula',
      'View results': 'Sonuçları görüntüle',
      Remove: 'Kaldır',
      From: 'En az',
      To: 'En çok',
      'Show more': 'Daha fazla göster',
      'Show less': 'Daha az göster',
      Previous: 'Önceki',
      Next: 'Sonraki',
      Close: 'Kapat',
      Open: 'Aç',
      Back: 'Geri',
      Reset: 'Sıfırla',
      Menu: 'Menü',
      Account: 'Hesap',
      'Log in': 'Giriş yap',
      Login: 'Giriş yap',
      'Sign in': 'Giriş yap',
      'Log out': 'Çıkış yap',
      'Sign out': 'Çıkış yap',
      'Create account': 'Hesap oluştur',
      Register: 'Kaydol',
      Email: 'E-posta',
      Password: 'Şifre',
      'First name': 'Ad',
      'Last name': 'Soyad',
      Name: 'Ad',
      Phone: 'Telefon',
      Message: 'Mesaj',
      Submit: 'Gönder',
      Send: 'Gönder',
      Subscribe: 'Abone ol',
      'Shop now': 'Şimdi alışveriş yap',
      'View all': 'Tümünü görüntüle',
      'Learn more': 'Daha fazla bilgi',
      'Read more': 'Devamını oku',
      'Free shipping': 'Ücretsiz kargo',
      'Powered by Shopify': 'Shopify altyapısıyla sunulmaktadır',
    }).map(([key, value]) => [normalize(key), value]),
  );

  const defaultTitles = new Set([
    normalize('Default Title'),
    normalize('Varsayılan Başlık'),
  ]);

  const blockedTags = new Set([
    'SCRIPT',
    'STYLE',
    'NOSCRIPT',
    'TEXTAREA',
    'CODE',
    'PRE',
  ]);

  const translatableAttributes = ['placeholder', 'aria-label', 'title'];

  const dynamicTranslation = (text) => {
    let match = text.match(/^(\d+)\s+products?$/i);
    if (match) return `${match[1]} ürün`;

    match = text.match(/^(\d+)\s+items?$/i);
    if (match) return `${match[1]} ürün`;

    match = text.match(/^(\d+)\s+results?$/i);
    if (match) return `${match[1]} sonuç`;

    match = text.match(/^View\s+(\d+)\s+(?:products?|items?)$/i);
    if (match) return `${match[1]} ürünü görüntüle`;

    match = text.match(/^View\s+(\d+)\s+results?$/i);
    if (match) return `${match[1]} sonucu görüntüle`;

    match = text.match(/^Showing\s+(\d+)\s+(?:products?|items?)$/i);
    if (match) return `${match[1]} ürün gösteriliyor`;

    match = text.match(/^Showing\s+(\d+)\s+results?$/i);
    if (match) return `${match[1]} sonuç gösteriliyor`;

    match = text.match(/^Page\s+(\d+)$/i);
    if (match) return `Sayfa ${match[1]}`;

    match = text.match(/^(\d+)\s+reviews?$/i);
    if (match) return `${match[1]} değerlendirme`;

    if (/^Decrease quantity(?: for .+)?$/i.test(text)) return 'Adedi azalt';
    if (/^Increase quantity(?: for .+)?$/i.test(text)) return 'Adedi artır';
    if (/^Search for .+$/i.test(text)) return 'Arama yap';

    return null;
  };

  const getTranslation = (value) => {
    const text = String(value || '').trim();
    if (!text) return null;

    const key = normalize(text);
    if (defaultTitles.has(key)) return '';

    return translations.get(key) || dynamicTranslation(text);
  };

  const translateTextNode = (node) => {
    const parent = node.parentElement;
    if (!parent || blockedTags.has(parent.tagName)) return;

    const original = node.nodeValue || '';
    const replacement = getTranslation(original);
    if (replacement === null) return;

    const leading = original.match(/^\s*/)?.[0] || '';
    const trailing = original.match(/\s*$/)?.[0] || '';
    const nextValue = `${leading}${replacement}${trailing}`;

    if (nextValue !== original) node.nodeValue = nextValue;
  };

  const translateAttributes = (element) => {
    if (!(element instanceof Element) || blockedTags.has(element.tagName)) return;

    translatableAttributes.forEach((attribute) => {
      if (!element.hasAttribute(attribute)) return;

      const original = element.getAttribute(attribute);
      const replacement = getTranslation(original);
      if (replacement !== null && replacement !== original) {
        element.setAttribute(attribute, replacement);
      }
    });

    if (
      element instanceof HTMLInputElement &&
      ['button', 'submit', 'reset'].includes(element.type)
    ) {
      const replacement = getTranslation(element.value);
      if (replacement !== null && replacement !== element.value) {
        element.value = replacement;
      }
    }
  };

  const translateDynamicCheckout = (root = document) => {
    const selector = [
      '.shopify-payment-button__button--unbranded',
      '.shopify-payment-button button',
      'button[name="checkout"]',
    ].join(',');

    const candidates = [];
    if (root instanceof Element && root.matches(selector)) candidates.push(root);
    root.querySelectorAll?.(selector).forEach((element) => candidates.push(element));

    candidates.forEach((button) => {
      const key = normalize(button.textContent);
      if (key !== 'buy it now' && key !== 'buy now') return;

      const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      let translated = false;
      let node;

      while ((node = walker.nextNode())) {
        const replacement = getTranslation(node.nodeValue);
        if (replacement !== null) {
          const original = node.nodeValue || '';
          const leading = original.match(/^\s*/)?.[0] || '';
          const trailing = original.match(/\s*$/)?.[0] || '';
          node.nodeValue = `${leading}${replacement}${trailing}`;
          translated = true;
        }
      }

      if (!translated && button.children.length === 0) {
        button.textContent = 'Şimdi satın al';
      }

      button.setAttribute('aria-label', 'Şimdi satın al');
    });
  };

  const removeStrayAddonButtons = (root = document) => {
    const buttons = [];
    if (root instanceof Element && root.matches('.diyor-addon-action')) buttons.push(root);
    root.querySelectorAll?.('.diyor-addon-action').forEach((button) => buttons.push(button));

    buttons.forEach((button) => {
      if (!button.closest('.diyor-accessory-card')) button.remove();
    });
  };

  const scan = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }

    if (
      root.nodeType !== Node.ELEMENT_NODE &&
      root.nodeType !== Node.DOCUMENT_NODE &&
      root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE
    ) {
      return;
    }

    removeStrayAddonButtons(root);

    if (root instanceof Element) translateAttributes(root);
    root.querySelectorAll?.('*').forEach(translateAttributes);

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: (node) =>
          blockedTags.has(node.parentElement?.tagName)
            ? NodeFilter.FILTER_REJECT
            : NodeFilter.FILTER_ACCEPT,
      },
    );

    let node;
    while ((node = walker.nextNode())) translateTextNode(node);

    translateDynamicCheckout(root);
  };

  const start = () => {
    scan(document.body);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          translateTextNode(mutation.target);
        }

        mutation.addedNodes.forEach(scan);
      });

      translateDynamicCheckout(document);
      removeStrayAddonButtons(document);
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    [250, 750, 1500, 3000].forEach((delay) => {
      window.setTimeout(() => scan(document.body), delay);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
